import React from 'react';
import {makeStyles} from "@mui/styles";
import HelpSectionTOC from "./HelpSectionTOC";
import Card from "@mui/material/Card";

const useStyles = makeStyles({
  root: {
    padding: 0
  },
  tocBody:{
    padding: "0 1rem 1rem"
  },
  toc:{
    padding: "0 0 0 1rem"
  },
  sticky: {
    position:"sticky",
    top: "-1px",
    "&: > div:first-child": {
      backgroundColor: "#c9ecff",
    },
    zIndex: 1,
    margin: "1rem 0 1rem 0",
    paddingBottom: "1px"
  },
  stickyRoot: {
    top: "0px",
    margin: "0 0 1rem 0",
  },
  top: {
    display: "flex",
    gap: "1rem",
    justifyContent: "space-between",
    backgroundColor: "inherit",
    color:"inherit"
  },
  topRoot: {
    padding:"2px 1rem 0",
    borderRadius: "0 0 4px 4px",
    backgroundColor: "#267ea6 !important",
    marginBottom: "0.25rem !important",
    color: "#ffffff",
    fontWeight: 500,
  },
  title: {
    flexGrow: 1,
    fontSize: '1.35rem',
  },
  name: {
    display:"flex",
    gap:"0.25em",
    marginBottom: "0.5rem",
  },
  topText: {
    flexBasis: "fit-content",
    padding: "4px 0",
  },
  locatorRoot: {
    display:"flex",
    flexWrap:"wrap",
    gap:"0.25rem",
    fontSize: '0.85rem',
    marginBottom: "0.35rem",
    fontWeight: 600,
  },
});

function HelpHome(props) {
  const { helpSections } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={`${classes.sticky} ${classes.stickyRoot}`}>
        <Card className={`${classes.top} ${classes.topRoot}`}>
          <div className={classes.topText}>
            <div className={classes.locatorRoot}>
              LifeNaut Help: Home
            </div>
            <div className={classes.name}>
              <div className={classes.title}>
                Table of Contents
              </div>
            </div>
          </div>
        </Card>
      </div>
      <div className={classes.tocBody}>
        {Object.entries(helpSections).map(([k, v]) => <div key={k}>
            <HelpSectionTOC section={v} onlyChildren={false} recursive={false} />
            <div className={classes.toc}>
              <HelpSectionTOC section={v} onlyChildren={true} recursive={false} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HelpHome
